import type { Ref } from 'vue'
import type { Router } from 'vue-router'
import {
  Cell as VanCell,
  Icon as VanIcon,
  List as VanList,
  PullRefresh as VanPullRefresh,
} from 'vant'
import type { Article } from '@/api/types.gen'

/**
 * 资料大全文章列表（下拉刷新 + 触底加载），文章列表页与文章搜索页共用。
 * prepend 放在列表最前面（如搜索页的空状态）。
 */
export function renderArticleList(opts: {
  router: Router
  list: Article[]
  refreshing: Ref<boolean>
  loading: Ref<boolean>
  error: Ref<boolean>
  finished: boolean
  onRefresh: () => void
  onLoad: () => void
  prepend?: unknown
}) {
  const { router, refreshing, loading, error } = opts
  return (
    <VanPullRefresh
      v-model={refreshing.value}
      pullingText="下拉可以刷新"
      loosingText="释放立即刷新"
      loadingText="正在刷新"
      successText="刷新完成"
      onRefresh={opts.onRefresh}
    >
      <VanList
        loading={loading.value}
        onUpdate:loading={(v: boolean) => (loading.value = v)}
        error={error.value}
        onUpdate:error={(v: boolean) => (error.value = v)}
        finished={opts.finished}
        finishedText=""
        errorText="请求失败，点击重新加载"
        immediateCheck={false}
        onLoad={opts.onLoad}
      >
        {opts.prepend}
        {opts.list.map((a, i) => (
          <VanCell
            key={a.id ?? i}
            class="list-item"
            onClick={() => router.push(`/articles/detail?id=${a.id}`)}
          >
            <div class="cell-top clearfix">
              <div class="cell-top-img">
                <img src={a.avatar || ''} alt="" referrerpolicy="no-referrer" />
              </div>
              <div class="cell-top-text">
                <p>{a.userName || '匿名'}</p>
                <div
                  innerHTML={(a.createdAt ?? '').replace('T', ' ').replace(/:\d{2}Z$/, '')}
                />
              </div>
            </div>
            <div class="content-box has-read">
              <p innerHTML={a.title ?? ''} />
            </div>
            <div class="operation-box clearfix">
              <div class="good">
                <VanIcon name="good-job" size="17" />
                {a.support ?? 0}
              </div>
              <div class="comment">
                <VanIcon name="chat" size="17" />
                {a.comments_count ?? 0}
              </div>
            </div>
          </VanCell>
        ))}
      </VanList>
    </VanPullRefresh>
  )
}
